"use client";

import React from "react";
import { CompanySelectWithModal } from "./components/CompanySelectWithModal";
import { DynamicSelectProps } from "./types";

// Company item type for the select
interface CompanyItem {
  id: string;
  name: string;
  company_name?: string;
}

interface CompanySelectProps extends DynamicSelectProps<CompanyItem> {
  expandInlineVariant?: "replace" | "floating";
}

// Export the CompanySelect component using the enhanced modal version
export const CompanySelect: React.FC<CompanySelectProps> = (props) => {
  return <CompanySelectWithModal {...props} />;
};

// Export the CompanyItem type for use in other components
export type { CompanyItem };
